'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dFeatures$0024 from "./presto.types$-Features$.js";
var $p;
/** @constructor */
function $c_Lpresto_SignDocumentPage$() {
}
export { $c_Lpresto_SignDocumentPage$ as $c_Lpresto_SignDocumentPage$ };
$p = $c_Lpresto_SignDocumentPage$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_SignDocumentPage$;
/** @constructor */
function $h_Lpresto_SignDocumentPage$() {
}
export { $h_Lpresto_SignDocumentPage$ as $h_Lpresto_SignDocumentPage$ };
$h_Lpresto_SignDocumentPage$.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return 197944519;
});
$p.l = (function() {
  return "SignDocumentPage";
});
$p.r = (function() {
  return 0;
});
$p.s = (function() {
  return "SignDocumentPage";
});
$p.j = (function(n) {
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.dm = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some($j_presto$002etypes$0024$002dFeatures$0024.$m_Lpresto_types$Features$().Lr);
});
var $d_Lpresto_SignDocumentPage$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_SignDocumentPage$, "presto.SignDocumentPage$", ({
  QO: 1,
  a2: 1,
  b: 1,
  c: 1,
  a: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_SignDocumentPage$ as $d_Lpresto_SignDocumentPage$ };
var $n_Lpresto_SignDocumentPage$;
function $m_Lpresto_SignDocumentPage$() {
  if ((!$n_Lpresto_SignDocumentPage$)) {
    $n_Lpresto_SignDocumentPage$ = new $c_Lpresto_SignDocumentPage$();
  }
  return $n_Lpresto_SignDocumentPage$;
}
export { $m_Lpresto_SignDocumentPage$ as $m_Lpresto_SignDocumentPage$ };
//# sourceMappingURL=presto.-Sign-Document-Page$.js.map
